import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxUploaderModule } from 'ngx-uploader';
import { NgxFilesizeModule } from 'ngx-filesize';
import { TranslateModule } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { HeaderComponent } from '../shared-components/header/header.component';
import { UploadSourcefileComponent } from '../features/upload-sourcefile/upload-sourcefile.component';
import { UploadProgressComponent } from '../shared-components/upload-progress/upload-progress.component';
import { UploadDatabookComponent } from '../features/upload-databook/upload-databook.component';
import { StepwizardComponent } from '../features/stepwizard/stepwizard.component';
import { SessionExpiredComponent } from '../features/sessionExpired/sessionExpired.component';
import { SelectadjustmentComponent } from '../features/selectadjustment/selectadjustment.component';
import { SchedulesComponent } from '../features/schedules/schedules.component';
@NgModule({
  declarations: [],
    // StepwizardComponent,
    // SessionExpiredComponent,
    // SelectadjustmentComponent,
    // SchedulesComponent],
  imports: [
    CommonModule,
    NgxUploaderModule,
    NgxFilesizeModule,
    TranslateModule
  ],
  exports: [
    CommonModule,
    NgxUploaderModule,
    NgxFilesizeModule
  ]
})
export class NgxModule {
}
